@if(personDetails(); as person){
<h5 class="d-flex justify-content-center mb-2">
	<i [class]="person.icon + ' ml-2'"></i>
	<span class="ms-2">| {{person.fullName}} | Person</span>
</h5>

<div class="d-flex flex-row justify-content-center flex-wrap gap-2 mt-3 mb-2">
	@for(chip of person.chips; track $index) {
	<span class="chip" [class]="chip.color">
		{{chip.label}}
		@if(chip.value) { <span>: {{chip.value}}</span> }
	</span>
	}
</div>

<kendo-tilelayout [columns]="8" [rowHeight]="50" [gap]="{ rows: 8, columns: 8 }">

	<kendo-tilelayout-item [col]="1" [colSpan]="2" [rowSpan]="3">
		<kendo-tilelayout-item-header class="fs-6">
			Contact
			@if(person.contactMethod) { <span class="ps-2">(Default: <b>{{person.contactMethod}}</b>)</span> }
		</kendo-tilelayout-item-header>
		<kendo-tilelayout-item-body class="d-flex flex-column gap-2">
			<link-button [link]="person.emailLink" />
			<div class="d-flex justify-content-between">
				@if(person.phoneLink){
				<link-button [link]="person.phoneLink" />
				}
				@if(person.smsLink){
				<link-button [link]="person.smsLink" />
				}
			</div>
		</kendo-tilelayout-item-body>
	</kendo-tilelayout-item>

	<kendo-tilelayout-item title="Details" [col]="3" [colSpan]="3" [rowSpan]="3">
		<kendo-tilelayout-item-body>
			<table class='pro-table pro-table-no-background pro-table-with-labels pro-table-without-border'>
				<tr>
					<td>Account Created Date</td>
					<td>{{person.formattedCreatedDate}}</td>
				</tr>
				<tr>
					<td>Last Login</td>
					<td>{{person.formattedLastLoginDate}}</td>
				</tr>
				<tr>
					<td>Learned about us?</td>
					<td>{{person.howLearn}}</td>
				</tr>
			</table>
		</kendo-tilelayout-item-body>
	</kendo-tilelayout-item>

	<kendo-tilelayout-item title="Signed Agreements" [col]="6" [colSpan]="3" [rowSpan]="3">
		<kendo-tilelayout-item-body>
			@for(a of person.agreements; track $index){
			<div>{{a.agreement}}, Version {{a.version}} (Signed on: {{a.formattedUpdatedDate}})</div>
			}
		</kendo-tilelayout-item-body>
	</kendo-tilelayout-item>

	<kendo-tilelayout-item title="Entrepreneurial Journey" [col]="1" [colSpan]="3" [rowSpan]="6">
		<kendo-tilelayout-item-body>
			<table class='pro-table pro-table-no-background pro-table-with-labels pro-table-without-border'>
				@for(journey of person.entrepreneurialJourney; track $index){
				<tr>
					<td>{{journey.label}}</td>
					<td>
						{{journey.value}}
						@if(journey.status) {<span>- {{journey.status}}</span>}
					</td>
				</tr>
				}

			</table>
		</kendo-tilelayout-item-body>
	</kendo-tilelayout-item>

	<kendo-tilelayout-item title="Volunteering Journey" [col]="4" [colSpan]="3" [rowSpan]="6">
		<kendo-tilelayout-item-body>Coming Soon !! </kendo-tilelayout-item-body>
	</kendo-tilelayout-item>

	<kendo-tilelayout-item title="Counts" [col]="7" [colSpan]="2" [rowSpan]="6">
		<kendo-tilelayout-item-body>
			<table class='pro-table pro-table-no-background pro-table-with-labels pro-table-without-border'>
				<tr>
					<td># Engagements</td>
					<td>{{person.counts.engagements}}</td>
				</tr>
				<tr>
					<td># Volunteerings</td>
					<td>{{person.counts.volunteerings}}</td>
				</tr>
				<tr>
					<td># Accelerator Applications</td>
					<td>{{person.counts.accApplications}}</td>
				</tr>
				<tr>
					<td># Notes</td>
					<td>{{person.counts.notes}}</td>
				</tr>
				<tr>
					<td># Awards</td>
					<td>{{person.counts.awardsAmount}}</td>
				</tr>
				<tr>
					<td># Contact Requests</td>
					<td>{{person.counts.contactRequests}}</td>
				</tr>
				<tr>
					<td># Emails Sent</td>
					<td>{{person.counts.emailsSent}}</td>
				</tr>
			</table>
		</kendo-tilelayout-item-body>
	</kendo-tilelayout-item>

</kendo-tilelayout>
}